export default __webpack_public_path__ + "static/media/Alfajor-dulce-de-leche.4431421f.jpg";